/* unplugin-vue-components disabled */import { render } from "./UploadSVG.vue?vue&type=template&id=566bafb2"
import script from "./UploadSVG.vue?vue&type=script&lang=js"
export * from "./UploadSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__